import ApiService from "../utils/ApiService";
import { getAuthToken } from "../utils/authUtils";
import { messaging } from "../utils/firebase.config";
import { getToken } from "firebase/messaging";

export const getSortedUniqueNotifications = (prevRecords, newRecords) => {
  const merged = [...prevRecords, ...newRecords];
  const uniqueArr = [...new Map(merged.map((item) => [item.id, item])).values()];
  return uniqueArr.sort((a, b) => b.timestamp - a.timestamp);
};

export const getNotificationTimeText = (dateTimeValue = null) => {
  if (!dateTimeValue) {
    return `0 minutes ago`;
  }

  const createdDate = new Date(dateTimeValue);
  let currentTime = Math.floor(Date.now() / 1000);
  let createdTime = Math.floor(createdDate.getTime() / 1000);

  const difInMinute = Math.floor((currentTime - createdTime) / 60);
  const difInHour = Math.floor(difInMinute / 60);
  const difInDay = Math.floor(difInHour / 24);

  if (difInDay > 0) {
    return `${difInDay} ${difInDay > 1 ? "days" : "day"} ago`;
  }

  if (difInHour > 0) {
    return `${difInHour} ${difInHour > 1 ? "hours" : "hour"} ago`;
  }

  return `${difInMinute} ${difInMinute > 1 ? "minutes" : "minute"} ago`;
};

const formatNotificationRecords = (records) => {
  return records.map((item) => {
    return {
      id: item.id,
      action: item.action,
      title: item.title,
      body: item.body,
      orderId: item?.orderId || "",
      orderNumber: "",
      phone: ``,
      orderStatus: "",
      paymentStatus: "",
      timeText: getNotificationTimeText(item.createdAt),
      isUnread: item.isUnread,
      userId: item.userId,
      timestamp: new Date(item.createdAt).getTime(),
    };
  });
};

export const getFCMToken = async () => {
  try {
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });

    if (token) {
      return token;
    } else {
      console.error("No registration token available.");
      return "";
    }
  } catch (error) {
    console.error("An error occurred while retrieving token. ", error);
    return "";
  }
};

export const registerDeviceToken = async (newToken = "") => {
  const userAuthToken = getAuthToken();

  if (!userAuthToken) {
    return;
  }

  let fcmToken = newToken;

  if (!fcmToken) {
    fcmToken = await getFCMToken();
  }

  if (fcmToken) {
    localStorage.setItem("fcmToken", fcmToken);

    const result = await ApiService.REGISTER_DEVICE_TOKEN(fcmToken, userAuthToken);
    console.log("----registerDeviceToken---api result", { result, fcmToken });
  }
};

export const getPushNotificationData = (data) => {
  return {
    title: data.title,
    options: {
      body: data.body,
      icon: "/logo.png",

      badge: "/logo.png",
      data: {
        url: "/", // Ensure you have this data for the click event,
        action: data.action,
        orderId: data?.orderId || ''
      },
    },
  };
};

export const getFormatedDate = (inputDate) => {
  if (!inputDate) {
    return "";
  }

  const d = new Date(inputDate);
  let dt = d.getDate();
  dt = dt.toString().padStart(2, "0");
  const fullMonth = d.toLocaleString("default", { month: "long" });

  return `${dt} ${fullMonth} ${d.getFullYear()}`;
};

export const getFormatedTime = (inputDate) => {
  if (!inputDate) {
    return "";
  }

  const date = new Date(inputDate);

  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};

export const fetchNotifications = async (user, restaurantId, page = 1) => {
  const result = {
    success: false,
    total: 0,
    records: [],
  };

  try {
    const params = { userId: user.id, restaurantId, page };
    const response = await ApiService.NOTIFICATION_LIST(params, user.token.token);

    if (response.status === "ok") {
      result.success = true;
      result.total = response.payload.total;
      result.records = formatNotificationRecords(response.payload.records);

      return result;
    }

    return result;
  } catch (err) {
    return result;
  }
};

export const navToNotificationDetails = (navigate, notificationItem) => {
  if (Object.keys(notificationItem).length === 0) {
    return;
  }

  if (notificationItem.action === "stock") {
    navigate(`/inventory/report`, { state: { testVar: "It is a test var" } });
    return;
  }

  navigate(`/order/${notificationItem.orderId}/details`, { state: { testVar: "It is a test var" } });
};

export const getNotificationElapsedTime = (savedTimeStamp) => {
  const currentTimestamp = Date.now();
  return Math.floor((currentTimestamp - savedTimeStamp) / 1000);
};
